import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { filterEnabledGeojson } from '../utils/geojsonHelpers'

const withFilteredFeatures = (source, features) => {
  return {
    ...(source || {}),
    type: 'FeatureCollection',
    features,
  }
}

export const useMapData = (selectedTenant = null) => {
  const treeFeatures = useSelector(state => state.treeFeatures)
  const filterSearch = useSelector(state => state.filterSearch)

  // LÓGICA PRINCIPAL: Decidir qué datos usar
  // 1. Filtros de búsqueda activos → usar datos filtrados, aplicando también filtro de tenant si corresponde
  // 2. Tenant específico seleccionado → filtrar localmente desde datos primarios
  // 3. "Todos" (sin tenant) → mostrar todos los árboles del cantón
  const currentMapData = useMemo(() => {
    const treeData = filterEnabledGeojson(treeFeatures.data)
    const filteredData = filterEnabledGeojson(filterSearch.filteredData)

    if (filterSearch.enable) {
      if (selectedTenant && filteredData?.features?.length > 0) {
        return withFilteredFeatures(
          filteredData,
          filteredData.features.filter(
            f => f.properties.tenantSlug === selectedTenant
          ),
        )
      }
      return filteredData
    }

    if (selectedTenant && treeData?.features?.length > 0) {
      const filtered = treeData.features.filter(
        f => f.properties.tenantSlug === selectedTenant
      )
      return withFilteredFeatures(treeData, filtered)
    }

    return treeData
  }, [filterSearch.enable, filterSearch.filteredData, selectedTenant, treeFeatures.data])

  const stats = {
    originalCount: filterEnabledGeojson(treeFeatures.data)?.features?.length || 0,
    filteredCount: currentMapData?.features?.length || 0,
    isUsingFilters: filterSearch.enable,
    isUsingTenantFilter: !!selectedTenant,
    hasOriginalData: (treeFeatures.data?.features?.length || 0) > 0,
    hasFilteredData: (currentMapData?.features?.length || 0) > 0,
    loadingFilters: filterSearch.loadingFilters,
  }

  return {
    // Datos actuales para mostrar en el mapa
    currentMapData,

    // Estadísticas útiles
    ...stats,

    // Acceso directo a los datos originales si se necesitan
    originalData: filterEnabledGeojson(treeFeatures.data),
    filteredData: filterEnabledGeojson(filterSearch.filteredData),
  }
}

// ALTERNATIVA: Selector simple para usar con useSelector
export const selectCurrentMapData = state => {
  return filterEnabledGeojson(
    state.filterSearch.enable
      ? state.filterSearch.filteredData
      : state.treeFeatures.data
  )
}

export const selectMapStats = state => {
  return {
    originalCount: filterEnabledGeojson(state.treeFeatures.data)?.features?.length || 0,
    filteredCount: filterEnabledGeojson(state.filterSearch.filteredData)?.features?.length || 0,
    isUsingFilters: state.filterSearch.enable,
    hasOriginalData: (state.treeFeatures.data?.features?.length || 0) > 0,
    hasFilteredData: state.filterSearch.filteredCount > 0,
    loadingFilters: state.filterSearch.loadingFilters,
  }
}
